import MediaSDK from '@/lib/ReverMediaSDK'

export default class Image {
  constructor(properties) {
    this.properties = {
      left: 0,
      top: 0,
      height: 0,
      width: 0,
      ...properties,
    }
    return this
  }

  removeBase64Prefix(imageString) {
    return imageString.split(',').pop()
  }

  async add(src) {
    if (!src) return
    let image =
      typeof src === 'string'
        ? (image = src)
        : (image = await MediaSDK.getBase64(src))
    const options = {
      coercionType: window.Office.CoercionType.Image,
      imageLeft: this.properties.left,
      imageTop: this.properties.top,
      imageWidth: this.properties.width,
      imageHeight: this.properties.height,
    }

    window.Office.context.document.setSelectedDataAsync(
      this.removeBase64Prefix(image),
      options,
      function(asyncResult) {
        if (asyncResult.status == 'failed') {
          console.log('Error: ' + asyncResult.error.message)
        }

        console.log('Async Result', asyncResult)
      }
    )
  }
}
